var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.23633 2H2.23633V2.5C2.23633 3.05 2.68633 3.5 3.23633 3.5H6.23633C6.78633 3.5 7.23633 3.05 7.23633 2.5V2H8.23633V4.5H9.23633V2C9.23633 1.45 8.78633 1 8.23633 1H6.14633C5.93633 0.42 5.38633 0 4.73633 0C4.08633 0 3.53633 0.42 3.32633 1H1.23633C0.686328 1 0.236328 1.45 0.236328 2V9C0.236328 9.55 0.686328 10 1.23633 10H4.23633V9H1.23633V2ZM4.73633 1C5.01133 1 5.23633 1.225 5.23633 1.5C5.23633 1.775 5.01133 2 4.73633 2C4.46133 2 4.23633 1.775 4.23633 1.5C4.23633 1.225 4.46133 1 4.73633 1Z",
    fill: "#24752B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61133 5.625C9.40633 5.42 9.06633 5.42 8.86133 5.625L6.49133 8L5.36133 6.875C5.15633 6.67 4.82133 6.67 4.61133 6.875C4.40633 7.08 4.40633 7.42 4.61133 7.625L6.13633 9.145C6.33133 9.34 6.64633 9.34 6.84133 9.145L9.60633 6.375C9.81633 6.17 9.81633 5.83 9.61133 5.625Z",
    fill: "#24752B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.9b3c7e8ade93a075ddb4c0b2ca475714.svg";
export { ForwardRef as ReactComponent };